import styled from 'styled-components';
import { Card } from 'antd';
import { Link } from 'react-router-dom';

interface StyledCardProps {
  token: any;
  minHeight?: string;
  cardShadow?: string;
  cardGradient?: string;
  cardTriangle?: string;
  cardTriangleShadow?: string;
}

export const StyledLinkButton = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: block;
  width: 100%;
`;

export const StyledCard = styled(Card)<StyledCardProps>`
  border: none;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  width: 100%;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  transition: box-shadow 0.3s ease, border-color 0.3s ease, filter 0.3s ease;
  height: 100%;
  min-height: ${(props) => props.minHeight || '142px'};
  background: ${({ token }) => token.colorPrimary};

  /* Top-left decorative triangle */
  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 48px;
    height: 48px;

    background: ${({ cardTriangle, token }) =>
      cardTriangle ||
      `linear-gradient(
        307deg,
        ${token.colorPrimary}B3 50%,
        ${token.colorPrimary}99 75%,
        ${token.colorPrimary}CC 100%
      )`};

    clip-path: polygon(0 0, 100% 0, 0 100%);
    box-shadow: ${({ cardTriangleShadow, token }) =>
      cardTriangleShadow || `0 0 10px ${token.colorPrimary}4D`};
    transition: opacity 0.3s ease, filter 0.3s ease;
  }

  /* Right-side accent */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 6px;
    background: ${({ cardGradient, token }) =>
      cardGradient ||
      `linear-gradient(
        180deg,
        ${token.colorPrimary}CC,
        ${token.colorPrimary}E6
      )`};
    border-radius: 0 20px 20px 0;
    transition: width 0.3s ease, opacity 0.3s ease;
  }

  &:hover {
    transform: none;
    box-shadow: ${({ cardShadow }) =>
      cardShadow || '0 14px 32px rgba(0, 0, 0, 0.26)'};
    filter: brightness(1.03);
  }

  &:hover::before {
    opacity: 1;
    filter: brightness(1.12);
  }

  &:hover::after {
    width: 8px;
  }

  .ant-card-body {
    padding: 40px 16px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @media (max-width: 480px) {
      padding: 28px 12px 14px;
    }

    @media (max-width: 380px) {
      padding: 20px 10px 10px;
    }
  }

  span {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
    color: white;
    text-align: center;
    padding-bottom: 6px;
    text-transform: capitalize;

    @media (max-width: 1400px) {
      font-size: 14px;
    }

    @media (max-width: 480px) {
      font-size: 13px;
    }

    @media (max-width: 380px) {
      font-size: 12px;
    }
  }
`;

export const IconWrapper = styled.div<{ token: any }>`
  background: linear-gradient(
    135deg,
    ${({ token }) => token.colorPrimary},
    ${({ token }) => token.colorPrimary}CC
  );

  border-radius: 50%;
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);

  svg {
    width: 48px;
    height: 48px;
    color: #ffffff;
  }
`;

export const StyledMeta = styled(Card.Meta)<{ token: any }>`
  position: relative;
  z-index: 1;

  .ant-card-meta-title {
    font-size: 15px;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 4px;
    text-align: center;
    white-space: pre-line !important;

    @media (max-width: 1400px) {
      font-size: 13px;
    }
  }

  .ant-card-meta-description {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    line-height: 1.35;
  }
`;
